export const handleGlobalClick = (event) => {
  // Emit event to hide the color picker popup
  if (event.target && !event.target.closest('li.color-picker')) {
    const hideColorPickerEvent = new MouseEvent('hide-color-picker');
    document.dispatchEvent(hideColorPickerEvent);
  }
};
